import React, { useCallback } from 'react'
import { Maybe } from '@graphql-tools/utils'
import { Image } from '@/atoms/Image'
import { paths } from '@/constants'
import { useLegacyEffect } from '@/molecules/utils'
import { RecommendedUpNextContent } from '@/services/RecommendationService'
import { useRecommendationTracking } from '@/services/RecommendedBannerService/useRecommendationTracking'
import { getCloudinaryImageUrl } from '@/utils/Cloudinary'

interface EndOfAssetRecommendationProps {
  recommendation: NonNullable<RecommendedUpNextContent[number]>
  handleRecommendationClick: (projectSlug: Maybe<string>) => void
}

export const EndOfAssetRecommendation: React.FC<EndOfAssetRecommendationProps> = ({
  recommendation,
  handleRecommendationClick,
}) => {
  const { trackRecommendation } = useRecommendationTracking()

  const onClick = useCallback(() => {
    handleRecommendationClick(recommendation?.title?.project?.slug)
    trackRecommendation({ type: 'PRESS', items: [{ id: recommendation.id as string }] })
  }, [handleRecommendationClick, trackRecommendation, recommendation?.title?.project?.slug, recommendation.id])

  useLegacyEffect(() => {
    trackRecommendation({ type: 'IMPRESSION', items: [{ id: recommendation.id as string }] })
  }, [trackRecommendation, recommendation.id])

  return (
    <a
      aria-label={recommendation.title?.name ?? ''}
      key={recommendation?.title?.id}
      href={`${paths.watch.index}/${recommendation?.title?.project?.slug}`}
      onClick={onClick}
    >
      <div className="relative inline-block h-fit pb-2 pr-4 duration-[400ms] ease-in-out hover:z-10 md:hover:scale-[1.05]">
        <Image
          aria-label={recommendation?.title?.name as string}
          alt={recommendation?.title?.name as string}
          src={getCloudinaryImageUrl({ path: recommendation?.title?.image?.cloudinaryPath, width: 380 })}
          height={253}
          width={450}
          className="rounded-xl bg-black"
        />
      </div>
    </a>
  )
}
